import mapboxgl from '!mapbox-gl';
import $ from 'jquery';

import { $Elements, Classes, Durations, Elements, Events } from '../global/constants';

export let mapMarkers = [];

mapboxgl.accessToken = 'pk.eyJ1IjoiZG91cnRoZSIsImEiOiJjbDlyaGg1N2owZ3dhM3VvN2o3d3hteng1In0.jkrNsRA4xc-jC1XgnbGiiw';

export let map = null;

$Elements.document.on(Events.page.enter, () => {

	if(document.getElementById('main-map')) {

		Elements.LoadingBar.classList.add(Classes.loading);

		map = new mapboxgl.Map({
			container: 'main-map',
			zoom: 6,
			center: [-0.4, 44.99],
			pitch: 0,
			bearing: 0,
			antialias: true,
			interactive: true,
			style: 'mapbox://styles/dourthe/cl9sb8me1000c14mi1l4jo4qe',
			attributionControl: false
		});

		map.on('load', () => {
			map.setStyle({ ...map.getStyle(), 'transition': { duration: Durations.animations.ms, delay: 0 } });
			$Elements.document.trigger('map.initialized');
			Elements.LoadingBar.classList.remove(Classes.loading);
		});
	}
	else {
		map = null;
	}
});

export function getLayerFeatures(layer) {
	return map.queryRenderedFeatures({ layers: [layer] })
}

export function getLayerFeaturesByProperty(layer, property, value) {
	return map.queryRenderedFeatures({ layers: [layer], filter: ['==', ['get', property], value] });
}

export function changeLayerFeaturesOpacity(layer, opacity = 1) {
	map.setPaintProperty(layer, 'fill-opacity', opacity);
}

export function changeLayerFeatureOpacityByProperty(layer, property, value, opacity = 1, defaultOpacity = 0.5) {
	map.setPaintProperty(layer, 'fill-opacity', ['match', ['get', property], value, opacity, defaultOpacity]);
}

export function getFeaturesBounds(features) {

	const bounds = new mapboxgl.LngLatBounds();

	if(Array.isArray(features) && features.length) {

		features.forEach(feature => {
			if(feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
				feature.geometry.coordinates.forEach(polygon => polygon.forEach(coordinates => bounds.extend(coordinates)));
			}
			else if(feature.geometry.type === 'Point') {
				bounds.extend(feature.geometry.coordinates);
			}
		});
	}

	return bounds;
}

export function getMapSettings() {

	const settings = document.getElementById('main-map');

	if(settings) {
		return JSON.parse(settings.dataset.settings);
	}

	return null;
}

export function easeTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = 1000;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.easeTo({ ...location, essential: true });
	});
}

export function flyTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = 1000;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.flyTo({ ...location, essential: true });
	});
}

export function fitBounds(bounds, options = {}) {

	if(typeof options.duration === 'undefined') {
		options.duration = 1000;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.fitBounds(bounds, { ...options, essential: true });
	});
}
